import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'

type Props = {
  town: string
}

const Heading = ({ town }: Props) => {
  return (
    <Grid item container xs={12}>
      <Box p={2}>
        <Typography variant="h6">{town}&#39;s Graphs</Typography>
      </Box>
    </Grid>
  )
}

export default Heading
